import { create } from 'zustand';
import { PaginationType } from '../types/pagination';
import {
  ExternalReviewItemType,
  fetchExternalReviewItems,
  FetchExternalReviewItemsRequest,
} from './api/external-reviews-items-api';
import { useAlertStore } from './use-alert-store';

interface Store {
  isLoadingFetch: boolean;
  externalReviewItems: ExternalReviewItemType[];
  fetchExternalReviewItems: (payload: FetchExternalReviewItemsRequest) => Promise<void>;
  pagination?: PaginationType;
}

export const useExternalReviewItemsStore = create<Store>((set, get) => ({
  isLoadingFetch: false,
  externalReviewItems: [], // Данные загрузятся из API
  fetchExternalReviewItems: async (params) => {
    set({ isLoadingFetch: true });

    try {
      const { external_review_items } = await fetchExternalReviewItems(params);

      const isInfinite = !!params.infinite;

      const updatedItems = isInfinite
        ? get().externalReviewItems.concat(external_review_items)
        : external_review_items;
      /** Пагинация только на клиенте (`Table` + `frontPagination`), не из ответа API */
      set({ externalReviewItems: updatedItems, pagination: undefined });
    } catch (e) {
      console.error('Ошибка при загрузке внешних отзывов:', e);
      useAlertStore
        .getState()
        .add({ label: 'Не удалось получить данные по внешним отзывам', variant: 'danger' });
    } finally {
      set({ isLoadingFetch: false });
    }
  },
}));
